// extracted by mini-css-extract-plugin
module.exports = {"appForm":"appForm_appForm__-gwco","error":"appForm_error__3Pf7s","buttons":"appForm_buttons__efXa2","loading":"appForm_loading__I1kO6"};